import * as betgalaxy from './MyBetsToggle.styles.betgalaxy';
import * as betprofessor from './MyBetsToggle.styles.betprofessor';
import * as betroyale from './MyBetsToggle.styles.betroyale';
import * as fiestabet from './MyBetsToggle.styles.fiestabet';
import * as goldenrush from './MyBetsToggle.styles.goldenrush';
import * as juicybet from './MyBetsToggle.styles.juicybet';
import * as puntcity from './MyBetsToggle.styles.puntcity';
import * as puntgenie from './MyBetsToggle.styles.puntgenie';
import * as questbet from './MyBetsToggle.styles.questbet';
import * as sterlingparker from './MyBetsToggle.styles.sterlingparker';
import * as vikingbet from './MyBetsToggle.styles.vikingbet';
import * as volcanobet from './MyBetsToggle.styles.volcanobet';
import * as wellbet from './MyBetsToggle.styles.wellbet';
import * as forsport from './MyBetsToggle.styles.forsport';
import * as junglebet from './MyBetsToggle.styles.junglebet';
import * as oldgill from './MyBetsToggle.styles.oldgill';
import * as sugarcastle from './MyBetsToggle.styles.sugarcastle';
import * as buffalobet from './MyBetsToggle.styles.buffalobet';
import * as titanbet from './MyBetsToggle.styles.titanbet';
import * as slambet from './MyBetsToggle.styles.slambet';
import * as gigabet from './MyBetsToggle.styles.gigabet';
import * as betstride from './MyBetsToggle.styles.betstride';
import * as templebet from './MyBetsToggle.styles.templebet';
import * as goldenbet888 from './MyBetsToggle.styles.goldenbet888';
import * as hyperbet from './MyBetsToggle.styles.hyperbet';
import * as bet777 from './MyBetsToggle.styles.bet777';
import * as chromabet from './MyBetsToggle.styles.chromabet';
import * as bet575 from './MyBetsToggle.styles.bet575';
import * as epicodds from './MyBetsToggle.styles.epicodds';
import * as pyramidbet from './MyBetsToggle.styles.pyramidbet';
import * as magnumbet from './MyBetsToggle.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
